import React, { useEffect } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import CustomHeading from "../../common/CustomHeading";
import CustomButton from "../../common/CustomButton";

import BulkUploadModal from "./BulkUploadModal";

import useOutsideClick from "../../../hooks/useOutsideClick";
import { ToastContainer } from "react-toastify";
import { Divider, getIcons, MenuItem } from "../../Constant/Constant";

import useInterestAndSource from "../../../hooks/useInterstAndSource";
import InterestTags from "./InterestTags";
import Leadsource from "./Leadsource";
import InterestLocation from "./InterestLocation";

const InterestAndSourceMain = () => {
  const {
    interestLocationData,
    sourceData,
    interestTagData,
    loading,

    menuOpen,
    setMenuOpen,
    isModalOpen,
    modalHeading,
    selectedFile,

    tagLimits,
    counts,
    limitsExceeded,

    dropdownRef,

    toggleMenu,
    openModal,
    closeModal,

    fetchInterestLocationData,
    fetchSourceData,
    fetchInterestTagData,

    createInterestLocation,
    createSource,
    createInterestTag,
    updateInterestLocation,
    updateSource,
    updateInterestTag,

    handleFileChange,
    handleBulkUpload,
    handleDownloadTemplate,
  } = useInterestAndSource();

  const icons = getIcons();

  useOutsideClick(dropdownRef, () => setMenuOpen(false));

  useEffect(() => {
    fetchInterestLocationData();
    fetchSourceData();
    fetchInterestTagData();
  }, []);

  const handleItemClick = (heading) => {
    openModal(heading);
  };

  return (
    <>
      <div className="bg-appGrayBackground h-screen">
        <AdminAppBar />
        <ToastContainer />

        <div className="bg-appGrayBackground mt-20 pt-4 px-6 pb-12">
          <div className="flex justify-between mt-4 px-2">
            <CustomHeading title={`Interest & Sources`} isIcon={true} />

            <div className="relative inline-block text-left" ref={dropdownRef}>
              <CustomButton
                label={"Bulk Import"}
                className="bg-customGreen rounded-md p-1 px-5 w-fit text-lg text-white h-10 text-center"
                onClick={toggleMenu}
              />

              {menuOpen && (
                <div className="absolute right-0 mt-4 w-64 bg-white rounded-xl shadow-lg z-10">
                  <div className="absolute -top-2 rounded right-4 w-4 h-4 bg-white rotate-45"></div>

                  <div className="py-2">
                    <MenuItem
                      onClick={() => handleItemClick("Interest Tags")}
                      icon={icons.interstTagIcon}
                      label="Interest Tags"
                      disabled={limitsExceeded.interestTag}
                      className={
                        limitsExceeded.interestTag
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                      }
                    />
                    <Divider />

                    <MenuItem
                      onClick={() => handleItemClick("Lead Sources")}
                      icon={icons.interestSourceIcon}
                      label="Lead Source"
                      disabled={limitsExceeded.leadSource}
                      className={
                        limitsExceeded.leadSource
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                      }
                    />
                    <Divider />

                    <MenuItem
                      onClick={() => handleItemClick("Location")}
                      icon={icons.interestLocationIcon}
                      label="Location"
                      disabled={limitsExceeded.location}
                      className={
                        limitsExceeded.location
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-col mt-7 gap-9 bg-white rounded-md shadow-md p-6">
            {/* Interest Tags Section */}

            <InterestTags
              tags={interestTagData}
              onCreate={createInterestTag}
              onUpdate={updateInterestTag}
              maxTags={tagLimits.interestTag}
              disableInput={counts.interestTag >= tagLimits.interestTag}
              loading={loading}
            />

            {/* Lead Source Section */}

            <Leadsource
              leadSources={sourceData}
              onCreate={createSource}
              onUpdate={updateSource}
              maxSources={tagLimits.leadSource}
              disableInput={counts.leadSource >= tagLimits.leadSource}
              loading={loading}
            />

            {/* Location Section */}

            <InterestLocation
              locations={interestLocationData}
              onCreate={createInterestLocation}
              onUpdate={updateInterestLocation}
              maxLocations={tagLimits.location}
              disableInput={counts.location >= tagLimits.location}
              loading={loading}
            />
          </div>
        </div>
      </div>

      <BulkUploadModal
        isOpen={isModalOpen}
        onClose={closeModal}
        modalHeading={modalHeading}
        selectedFile={selectedFile}
        onFileChange={handleFileChange}
        onUpload={handleBulkUpload}
        onDownloadTemplate={handleDownloadTemplate}
        currentCount={
          modalHeading === "Interest Tags"
            ? counts.interestTag
            : modalHeading === "Lead Sources"
            ? counts.leadSource
            : modalHeading === "Location"
            ? counts.location
            : 0
        }
        maxCount={
          modalHeading === "Interest Tags"
            ? tagLimits.interestTag
            : modalHeading === "Lead Sources"
            ? tagLimits.leadSource
            : modalHeading === "Location"
            ? tagLimits.location
            : 0
        }
      />
    </>
  );
};

export default InterestAndSourceMain;
